import { FAIcon } from "../core/components/faIcon";
import { IsSearchField } from "../core/components/isSearchField";
import { MultiSelect } from "../core/components/multiSelect";
import { DropDownList } from "../core/components/dropDownList";
import { Grid } from "../core/components/grid";
import { AppHelper } from "../appHelper";
import { AnnualVacationEditAppProps, AnnualVacationEditApp } from "./annualVacationEdit";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import { PageTitle } from "../core/components/pageTitle";
import { Helper } from "../core/util/helper";
import { General } from "../../siteManagement/general";
import { ComponentHelper } from "../core/util/componentHelper";
import { SheetEventType } from "../../siteManagement/sheet";
import { NotificationHelper } from "../core/util/notificationHelper";
import { RightDrawerContainer } from "../core/components/rightDrawerContainer";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { getQueryParamsFromSearch } from "../statistics/services";
import { AppBaseProps, Entity, Metadata } from "../core/components/commonApp";
import React from "react"
import ReactDOM from "react-dom";
interface VacationViewModel extends Entity {
    VacationRessProperties: Array<VacationRessProperties>;
}

export interface VacationRessProperties extends Entity {
    RessNr: string;
    VorName: string;
    Name: string;
    Jahresurlaub: number;
    SonderUrlaub?: number;
    RestUrlaubVorjahr?: number;
    GesamterUrlaub?: number;
    GenehmigterUrlaub?: number;
    Geplant?: number;
    VerfuegbarerUrlaub?: number;
    SonderUrlaubGrund?: string;
    Jahr: number;
}

export interface AnnualVacationViewAppProps extends AppBaseProps {
    data: VacationViewModel;
    metadataVacationEdit: Metadata;
}

export interface VacationListFilter {
    RessNr: string;
    Ogrnr?: number[];
    GrNr?: number[];
    Jahr: number;
}

export class AnnualVacationViewApp extends React.Component<AnnualVacationViewAppProps, any> {
    private _sheetRef: JQuery;
    private _rightDrawerContainer: any;
    common = new AppHelper();
    setTabTitle = true;
    vacationListGridOptions = [];
    translations = [];
    filter: VacationListFilter = { RessNr: null, Ogrnr: null, GrNr: null, Jahr: new Date().getFullYear() };

    constructor(props: AnnualVacationViewAppProps) {
        super(props);
        this.setEvents();
        this.loadFilterFromUrl();
        this._refreshData();
        this.common.enableHooks = true;
        this.common.init(this);
        this._rightDrawerContainer = props.metadata.rightDrawerContainer;
        this._sheetRef = General.Sheet.Manager.getTopMostSheet().elements.getLeftDrawerElementRef();

    }

    private setEvents = () => {
        $(document).bind("keyup", this.onKeyUp);
    }

    private onKeyUp = (e: JQuery.KeyUpEvent) => {
        const enter = 13;
        const keyCode = e.keyCode;
        switch (keyCode) {
            case enter:
                this._refreshData();
                break;
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    private _handleSelectionChanged = (dataItem: VacationRessProperties) => {
        if (dataItem !== null) {
            let entity: VacationRessProperties = JSON.parse(JSON.stringify(dataItem));
            const sheet = General.Sheet.Manager.createSheet();
            sheet.show(() => {
                const props: AnnualVacationEditAppProps = {
                    context: this.props.context,
                    dataSources: this.props.dataSources,
                    title: this.translations["WebSMS.Vacation.EintragBearbeiten"],
                    metadata: this.props.metadataVacationEdit,
                    entity: entity,
                    isWindow: true
                };
                sheet.mountContent(AnnualVacationEditApp, props);
                sheet.bind(SheetEventType.Close, this._refreshData);
            });
        }
    }

    private _handleOnChangeFilter = (field: { model: string }, value: any, dataItem?: any) => {
        if (field.model == "RessNr") {
            this.filter.RessNr = value;
        }
        if (field.model == "Ogrnr") {
            this.filter.Ogrnr = value;
        }
        if (field.model == "GrNr") {
            this.filter.GrNr = value;
        }
        if (field.model == "Jahr") {
            this.filter.Jahr = value;
        }
        this.setState({});
    }

    private _handleFilterClick = () => {
        this._refreshData();
    }

    private _refreshData = async () => {
        let result = await HTTPService.post<JsonResultClass<VacationRessProperties[]>>("Vacation/GetVacationList", this.filter)
        if (result.Code == 0) {
            Helper.setArrayValues(this.props.data.VacationRessProperties, result.Data);
            this.setState({});
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    getComponent = () => {
        let grid = <Grid
            data={this.props.data.VacationRessProperties}
            options={this.vacationListGridOptions}
            onSelectionChanged={this._handleSelectionChanged}
            id="annualVacation" />;
        return grid;
    }
    renderFilter = () => {
        let issfProps = ComponentHelper.createFactory().getDefaultSearchFieldProps();
        issfProps.value = this.filter.RessNr;
        //issfProps.disabled = true;
        //issfProps.field.deleteButtonEnabled = true;
        //issfProps.field.readOnlyTextField = true;
        issfProps.field.searchWindowTitle = this.translations["Ressource.Ressourcensuche"];
        issfProps.field.searchWindowUrl = "DynamicSearch/Window/Resource";
        issfProps.field.model = "RessNr";
        issfProps.onChange = this._handleOnChangeFilter;

        let multiSelectOgrnr = ComponentHelper.createFactory().getDefaultMultiSelectProps();
        multiSelectOgrnr.value = this.filter.Ogrnr;
        multiSelectOgrnr.field.model = "Ogrnr";
        multiSelectOgrnr.field.dataSourceUrl = "UserSettingsLookup/GetOGrNrs";
        multiSelectOgrnr.field.dataTextField = "Obergruppe";
        multiSelectOgrnr.field.dataValueField = "Ogrnr";
        multiSelectOgrnr.field.primitiveValue = true;
        multiSelectOgrnr.field.readOnly = true;

        multiSelectOgrnr.onChange = this._handleOnChangeFilter;

        let multiSelectGrnr = ComponentHelper.createFactory().getDefaultMultiSelectProps();
        multiSelectGrnr.value = this.filter.GrNr;
        multiSelectGrnr.field.model = "GrNr";
        multiSelectGrnr.field.dataSourceUrl = "UserSettingsLookup/GetGrNrs";
        multiSelectGrnr.field.dataTextField = "Gruppe";
        multiSelectGrnr.field.dataValueField = "GrNr";
        multiSelectGrnr.field.primitiveValue = true;
        multiSelectGrnr.onChange = this._handleOnChangeFilter;

        let dropDownJahr = ComponentHelper.createFactory().getDefaultDropDownProps();
        dropDownJahr.value = this.filter.Jahr;
        dropDownJahr.field.model = "Jahr";
        dropDownJahr.field.dataSourceUrl = "Vacation/GetJahr";
        dropDownJahr.field.dataTextField = "Text";
        dropDownJahr.field.dataValueField = "Id";
        dropDownJahr.field.optionLabel = "";
        dropDownJahr.onChange = this._handleOnChangeFilter;
        dropDownJahr.field.listWidth = 227;



        let filter =
            <div style={{ margin: "5px", marginRight: "8px", display: "flex", flexWrap: "wrap" }} >
                <div style={{ width: "100%", marginTop: "10px", marginBottom: "3px" }}>
                    <button className="k-button" onClick={this._handleFilterClick} style={{ backgroundColor: "var( --primary-color)", color: "white", border: "none", width: "100%", height: "36px", fontSize: "1.2em", display: "flex", alignItems: "center" }}>
                        <FAIcon name="search" style={{ marginRight: "5px" }} />
                        {this.translations["Standard.Suche"]}
                    </button>
                </div>
                <div style={{ width: "100%", marginTop: "10px", marginBottom: "3px" }}>
                    <label>{this.translations["Field.Ressource.ressnr"]}</label>
                    <div style={{ width: "100%", marginTop: "5px" }}>
                        <IsSearchField {...issfProps} />
                    </div>
                </div>
                <div style={{ width: "100%", marginTop: "10px", marginBottom: "3px" }}>
                    <label>{this.translations["WebCRM.Administration.Obergruppe"]}</label>
                    <div style={{ width: "100%", marginTop: "5px" }}>
                        <MultiSelect {...multiSelectOgrnr} />
                    </div>
                </div>
                <div style={{ width: "100%", marginTop: "10px", marginBottom: "3px" }}>
                    <label>{this.translations["WebCRM.Administration.Gruppe"]}</label>
                    <div style={{ width: "100%", marginTop: "5px" }}>
                        <MultiSelect {...multiSelectGrnr} />
                    </div>
                </div>
                <div style={{ width: "100%", marginTop: "10px", marginBottom: "3px" }}>
                    <label>{this.translations["Statistik.Jahr"]}</label>
                    <div style={{ width: "100%", marginTop: "5px" }}>
                        <DropDownList {...dropDownJahr} />
                    </div>
                </div>
            </div>;
        return ReactDOM.createPortal(filter, this._sheetRef[0]);
    }
    private _renderRightDrawerComponent = () => {
        if (this._rightDrawerContainer !== null) {
            let entity: Entity = {
                IsNew: true,
                RecordRight: {
                    CanRead: true, CanWrite: true
                },
                IsWatchable: false,
                IsWatched: false
            };

            return <RightDrawerContainer
                moduleName={this._rightDrawerContainer.moduleName}
                appName={this._rightDrawerContainer.appName}
                visible={this._rightDrawerContainer.visible}
                width={this._rightDrawerContainer.width}
                customProps={this._rightDrawerContainer.props}
                entity={entity}
                renderAlways={this._rightDrawerContainer.renderAlways}
                multipleComponents={this._rightDrawerContainer.multipleComponents}
                helpUrl={this._rightDrawerContainer.helpUrl}
            />
        }

        return null;
    }
    private loadFilterFromUrl() {
        const searchParams: {
            ressnr: string;
            ogrnr: string | string[];
            grnr: string;
            jahr: string;
        } = getQueryParamsFromSearch() as any;
        if (searchParams) {
            if (searchParams.ressnr) {
                this.filter.RessNr = searchParams.ressnr;
            }
            if (searchParams.ogrnr) {
                this.filter.Ogrnr = Array.isArray(searchParams.ogrnr) ? searchParams.ogrnr.map(x => Number(x)) : [Number(searchParams.ogrnr)];
            }
            if (searchParams.grnr) {
                this.filter.GrNr = Array.isArray(searchParams.grnr) ? searchParams.grnr.map(x => Number(x)) : [Number(searchParams.grnr)];
            }
            if (searchParams.jahr) {
                this.filter.Jahr = Number(searchParams.jahr);
            }
        }
    }

    componentWillUnmount() {
        $(document).unbind("keyup", this.onKeyUp);
    }

    render() {
        return (
            <React.Fragment>
                {this.renderFilter()}
                {this._renderRightDrawerComponent()}
                <FullHeightContainer>
                    <PageTitle title={this.props.title} />
                    {this.getComponent()}
                </FullHeightContainer>
            </React.Fragment>
        );
    };
}
